import { rem } from 'polished';
import React, { DetailedHTMLProps, AnchorHTMLAttributes } from 'react';
import styled from 'styled-components';

import { green } from '@vimeo/iris/color';
import { Pop } from '@vimeo/iris/components';
import { Text } from '@vimeo/iris/typography';

interface LinkProps
  extends DetailedHTMLProps<AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> {
  href: string;
  label: string;
  upgrade?: boolean;
  title?: string;
  'aria-label'?: string;
}

export const PopLink = ({ href, label, upgrade, ...props }: LinkProps) => {
  return (
    <a
      href={href}
      style={{ textDecoration: 'none', cursor: 'pointer' }}
      target="_blank"
      rel="noreferrer"
      {...props}
    >
      <PopItem>{upgrade ? <Upgrade>{label}</Upgrade> : <Label>{label}</Label>}</PopItem>
    </a>
  );
};

const PopItem = styled(Pop.Item)`
  padding: ${rem(6)} ${rem(16)};
`;

const Label = styled(Text)`
  font-size: ${rem(14)};
`;

const Upgrade = styled(Text)`
  font-size: ${rem(14)};
  /* IE11 Fallback */
  color: ${green(500)};
  @supports (-webkit-background-clip: text) {
    background: linear-gradient(to right, #22b654, #15c1ca);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;
